var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 31,
    viewBox: "0 0 104 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14234_2391)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8712 25.7619L18.9601 7.08723L15.0731 4.61667L3.86093 4.55933L3.76069 25.6898L18.8712 25.7619Z",
    fill: "#005386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8712 25.7619L18.9601 7.08723L15.0731 4.61667L3.86093 4.55933L3.76069 25.6898L18.8712 25.7619Z",
    fill: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M18.638 25.4713L18.7084 7.46865L14.9946 5.08434L4.28891 5.0239L4.21019 25.3898L18.638 25.4713Z",
    fill: "#DEF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.962 7.08374L15.0742 4.61267L16.3214 7.8695L18.962 7.08374Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22336 26.8339C5.95875 26.6508 7.21711 25.0955 7.03398 23.3601C6.85085 21.6247 5.29557 20.3664 3.56018 20.5495C1.82478 20.7326 0.566427 22.2879 0.749559 24.0233C0.932691 25.7587 2.48796 27.0171 4.22336 26.8339Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6534 25.4958C6.64905 24.5231 6.66766 22.9275 5.69495 21.9318C4.72224 20.9362 3.12657 20.9175 2.13092 21.8903C1.13526 22.863 1.11666 24.4586 2.08936 25.4543C3.06207 26.4499 4.65774 26.4685 5.6534 25.4958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4173 23.3086L4.29569 23.2911L4.31079 22.1758L3.50801 22.167L3.49034 23.2866L2.37523 23.2735L2.36638 24.0762L3.48547 24.0889L3.47278 25.208L4.27854 25.2166L4.28815 24.0968L5.40724 24.1095L5.4173 23.3086Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 8.96509L15.683 8.96624",
    stroke: "#8DBDE2",
    strokeWidth: 0.299938,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 10.2261L15.683 10.2272",
    stroke: "#8DBDE2",
    strokeWidth: 0.299938,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 11.4871L15.683 11.4882",
    stroke: "#8DBDE2",
    strokeWidth: 0.299938,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 12.749L15.683 12.7502",
    stroke: "#8DBDE2",
    strokeWidth: 0.299938,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 14.01L15.683 14.0112",
    stroke: "#8DBDE2",
    strokeWidth: 0.299938,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 15.2721L15.683 15.2732",
    stroke: "#8DBDE2",
    strokeWidth: 0.299938,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 16.5331L15.683 16.5342",
    stroke: "#8DBDE2",
    strokeWidth: 0.299938,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 17.795H10.6391",
    stroke: "#8DBDE2",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8504 0.25H31.1094V29.928H68.8504V0.25Z",
    fill: "white",
    stroke: "#C1E5F8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7969 1.45105H67.0849V28.1511H32.7969V1.45105Z",
    fill: "#DEF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0859 10.7131C65.4859 8.53805 63.9939 7.94806 61.9949 9.85706C58.9389 12.7731 56.7319 19.8071 54.8649 19.2921C52.9979 18.7771 52.9979 15.861 51.2999 13.802C49.6019 11.743 46.7169 15.861 41.4539 20.492C38.9601 22.6923 36.0004 24.2991 32.7969 25.1921V28.392H67.0849L67.0859 10.7131Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.95 8.93059C45.339 6.54576 43.7211 4.29711 41.3362 3.90809C38.9514 3.51908 36.7028 5.13701 36.3137 7.52184C35.9247 9.90668 37.5427 12.1553 39.9275 12.5443C42.3123 12.9334 44.561 11.3154 44.95 8.93059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.253 24.775C102.253 24.9014 102.202 25.0226 102.113 25.112C102.024 25.2014 101.902 25.2517 101.776 25.252H77.27C77.1435 25.2517 77.0224 25.2014 76.933 25.112C76.8436 25.0226 76.7932 24.9014 76.793 24.775V6.08599C76.7935 5.95973 76.844 5.83881 76.9333 5.74963C77.0227 5.66045 77.1437 5.61025 77.27 5.60999H101.777C101.903 5.61025 102.025 5.66059 102.114 5.74999C102.203 5.83938 102.254 5.96056 102.254 6.08698L102.253 24.775Z",
    fill: "#DEF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.178 25.456C103.178 25.5914 103.124 25.7211 103.028 25.8168C102.932 25.9125 102.803 25.9665 102.667 25.967H76.3743C76.2389 25.9665 76.1092 25.9125 76.0135 25.8168C75.9178 25.7211 75.8638 25.5914 75.8633 25.456V5.40404C75.8641 5.26885 75.9182 5.13944 76.0139 5.04394C76.1096 4.94844 76.2391 4.89457 76.3743 4.89404H102.663C102.799 4.89457 102.928 4.94858 103.024 5.04429C103.12 5.14001 103.174 5.26968 103.174 5.40504L103.178 25.456Z",
    stroke: "#C1E5F8",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6592 10.767C84.6592 10.243 85.0312 10.028 85.4852 10.29L93.5592 14.952C93.6604 14.9842 93.7487 15.0477 93.8113 15.1334C93.874 15.219 93.9078 15.3224 93.9078 15.4285C93.9078 15.5347 93.874 15.638 93.8113 15.7237C93.7487 15.8094 93.6604 15.8729 93.5592 15.905L85.4822 20.568C85.0282 20.83 84.6562 20.616 84.6562 20.091L84.6592 10.767Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5482 10.9061L85.4822 10.2901C85.0282 10.0281 84.6562 10.2421 84.6562 10.7671V20.0941C84.6562 20.6181 85.0282 20.8331 85.4822 20.5711L86.5482 19.9551V10.9061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.771 9.28002C100.771 9.35579 100.741 9.42838 100.687 9.48196C100.634 9.53554 100.561 9.56575 100.485 9.56602H98.4852C98.4095 9.56575 98.3369 9.53554 98.2833 9.48196C98.2297 9.42838 98.1995 9.35579 98.1992 9.28002V7.28002C98.1995 7.20425 98.2297 7.13165 98.2833 7.07808C98.3369 7.0245 98.4095 6.99428 98.4852 6.99402H100.485C100.561 6.99428 100.634 7.0245 100.687 7.07808C100.741 7.13165 100.771 7.20425 100.771 7.28002V9.28002Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.771 12.857C100.771 12.9328 100.741 13.0054 100.687 13.059C100.634 13.1126 100.561 13.1428 100.485 13.143H98.4852C98.4095 13.1428 98.3369 13.1126 98.2833 13.059C98.2297 13.0054 98.1995 12.9328 98.1992 12.857V10.857C98.1995 10.7813 98.2297 10.7087 98.2833 10.6551C98.3369 10.6015 98.4095 10.5713 98.4852 10.571H100.485C100.561 10.5713 100.634 10.6015 100.687 10.6551C100.741 10.7087 100.771 10.7813 100.771 10.857V12.857Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.771 16.4351C100.771 16.5108 100.741 16.5834 100.687 16.637C100.634 16.6906 100.561 16.7208 100.485 16.721H98.4852C98.4095 16.7208 98.3369 16.6906 98.2833 16.637C98.2297 16.5834 98.1995 16.5108 98.1992 16.4351V14.4351C98.1995 14.3593 98.2297 14.2867 98.2833 14.2331C98.3369 14.1795 98.4095 14.1493 98.4852 14.149H100.485C100.561 14.1493 100.634 14.1795 100.687 14.2331C100.741 14.2867 100.771 14.3593 100.771 14.4351V16.4351Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.771 20.0121C100.771 20.0878 100.741 20.1604 100.687 20.214C100.634 20.2676 100.561 20.2978 100.485 20.2981H98.4852C98.4095 20.2978 98.3369 20.2676 98.2833 20.214C98.2297 20.1604 98.1995 20.0878 98.1992 20.0121V18.0121C98.1995 17.9363 98.2297 17.8637 98.2833 17.8101C98.3369 17.7565 98.4095 17.7263 98.4852 17.7261H100.485C100.561 17.7263 100.634 17.7565 100.687 17.8101C100.741 17.8637 100.771 17.9363 100.771 18.0121V20.0121Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.771 23.582C100.771 23.6578 100.741 23.7304 100.687 23.784C100.634 23.8375 100.561 23.8677 100.485 23.868H98.4852C98.4095 23.8677 98.3369 23.8375 98.2833 23.784C98.2297 23.7304 98.1995 23.6578 98.1992 23.582V21.582C98.1995 21.5062 98.2297 21.4337 98.2833 21.3801C98.3369 21.3265 98.4095 21.2963 98.4852 21.296H100.485C100.561 21.2963 100.634 21.3265 100.687 21.3801C100.741 21.4337 100.771 21.5062 100.771 21.582V23.582Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8454 9.28002C80.8452 9.35579 80.815 9.42838 80.7614 9.48196C80.7078 9.53554 80.6352 9.56575 80.5594 9.56602H78.5594C78.4837 9.56575 78.4111 9.53554 78.3575 9.48196C78.3039 9.42838 78.2737 9.35579 78.2734 9.28002V7.28002C78.2737 7.20425 78.3039 7.13165 78.3575 7.07808C78.4111 7.0245 78.4837 6.99428 78.5594 6.99402H80.5594C80.6352 6.99428 80.7078 7.0245 80.7614 7.07808C80.815 7.13165 80.8452 7.20425 80.8454 7.28002V9.28002Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8454 12.857C80.8452 12.9328 80.815 13.0054 80.7614 13.059C80.7078 13.1126 80.6352 13.1428 80.5594 13.143H78.5594C78.4837 13.1428 78.4111 13.1126 78.3575 13.059C78.3039 13.0054 78.2737 12.9328 78.2734 12.857V10.857C78.2737 10.7813 78.3039 10.7087 78.3575 10.6551C78.4111 10.6015 78.4837 10.5713 78.5594 10.571H80.5594C80.6352 10.5713 80.7078 10.6015 80.7614 10.6551C80.815 10.7087 80.8452 10.7813 80.8454 10.857V12.857Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8454 16.4351C80.8452 16.5108 80.815 16.5834 80.7614 16.637C80.7078 16.6906 80.6352 16.7208 80.5594 16.721H78.5594C78.4837 16.7208 78.4111 16.6906 78.3575 16.637C78.3039 16.5834 78.2737 16.5108 78.2734 16.4351V14.4351C78.2737 14.3593 78.3039 14.2867 78.3575 14.2331C78.4111 14.1795 78.4837 14.1493 78.5594 14.149H80.5594C80.6352 14.1493 80.7078 14.1795 80.7614 14.2331C80.815 14.2867 80.8452 14.3593 80.8454 14.4351V16.4351Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8454 20.0121C80.8452 20.0878 80.815 20.1604 80.7614 20.214C80.7078 20.2676 80.6352 20.2978 80.5594 20.2981H78.5594C78.4837 20.2978 78.4111 20.2676 78.3575 20.214C78.3039 20.1604 78.2737 20.0878 78.2734 20.0121V18.0121C78.2737 17.9363 78.3039 17.8637 78.3575 17.8101C78.4111 17.7565 78.4837 17.7263 78.5594 17.7261H80.5594C80.6352 17.7263 80.7078 17.7565 80.7614 17.8101C80.815 17.8637 80.8452 17.9363 80.8454 18.0121V20.0121Z",
    fill: "#8DBDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8454 23.582C80.8452 23.6578 80.815 23.7304 80.7614 23.784C80.7078 23.8375 80.6352 23.8677 80.5594 23.868H78.5594C78.4837 23.8677 78.4111 23.8375 78.3575 23.784C78.3039 23.7304 78.2737 23.6578 78.2734 23.582V21.582C78.2737 21.5062 78.3039 21.4337 78.3575 21.3801C78.4111 21.3265 78.4837 21.2963 78.5594 21.296H80.5594C80.6352 21.2963 80.7078 21.3265 80.7614 21.3801C80.815 21.4337 80.8452 21.5062 80.8454 21.582V23.582Z",
    fill: "#8DBDE2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14234_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.326,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentImage);
export default __webpack_public_path__ + "static/media/attachment-image.4c9ee6a342c08256f9ba4509bdffe19e.svg";
export { ForwardRef as ReactComponent };